import { useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import classNames from "classnames";

import styles from "./AdminsList.module.css";
import PropTypes from "prop-types";
import AdminItem from "../AdminItem";
import nextId from "react-id-generator";

/**
 *
 * List of admins with a header.
 */

export function AdminsList({ admins, onClick }) {
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref, {
    applyRubberBandEffect: true,
  }); // Now we pass the reference to the useDraggable hook:
  const draggerId = "adminsDraggerId" + nextId();
  //console.log(draggerId);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>Name</div>
        <div>IBO #</div>
        <div>Admin Access</div>
      </div>
      <div className={styles.dragger} {...events} ref={ref} id={draggerId}>
        {admins.map((item, index) => (
          <div
            className={
              index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
            }
            key={index}
          >
            <AdminItem adminInfo={item} onClick={() => onClick(item)} />
          </div>
        ))}
      </div>
    </div>
  );
}

AdminsList.propTypes = {
  admins: PropTypes.arrayOf(PropTypes.object),
};
